import { render, staticRenderFns } from "./review-group.vue?vue&type=template&id=31f3e3a9&scoped=true"
import script from "./review-group.vue?vue&type=script&lang=js"
export * from "./review-group.vue?vue&type=script&lang=js"
import style0 from "./review-group.vue?vue&type=style&index=0&id=31f3e3a9&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "31f3e3a9",
  null
  
)

export default component.exports